<template>
  <div class="global-loader">
    <div class="loader-card"></div>
    <div class="loader-line"></div>
    <div class="loader-line short"></div>
  </div>
</template>




<style scoped>

.global-loader {
  padding: 20px;
  max-width: 1200px;
  margin: auto;
}

.loader-card,
.loader-line {
  background: linear-gradient(
    90deg,
    #eee 25%,
    #f5f5f5 37%,
    #eee 63%
  );
  background-size: 400% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 8px;
}

.loader-card {
  height: 300px;
}

.loader-line {
  height: 18px;
  margin-top: 16px;
}

.loader-line.short {
  width: 60%;
}

@keyframes shimmer {
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}
</style>
